import React from "react";
import Statistics from './Statistics'
function MachineConf({item}) {
  return (
    <>
        <Statistics></Statistics>
    </>
  );
}

export default MachineConf;
